var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      nativeOn: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit()
        },
      },
    },
    [
      _c("v-text-field", {
        attrs: {
          autofocus: "",
          label: "Login",
          name: "login",
          "prepend-icon": "mdi-account",
          "error-messages": _vm.validationErrors.login,
          disabled: _vm.loading,
        },
        on: {
          input: function ($event) {
            return _vm.$v.fields.login.$touch()
          },
        },
        model: {
          value: _vm.fields.login,
          callback: function ($$v) {
            _vm.$set(_vm.fields, "login", $$v)
          },
          expression: "fields.login",
        },
      }),
      _c("v-text-field", {
        attrs: {
          label: "Password",
          name: "password",
          "prepend-icon": "mdi-lock",
          counter: "",
          "append-icon": _vm.passwdShown ? "mdi-eye" : "mdi-eye-off",
          type: _vm.passwdShown ? "text" : "password",
          hint: `Password must be at least ${_vm.minPasswdLength} characters length`,
          "error-messages": _vm.validationErrors.password,
          disabled: _vm.loading,
        },
        on: {
          "click:append": function ($event) {
            _vm.passwdShown = !_vm.passwdShown
          },
          input: function ($event) {
            return _vm.$v.fields.password.$touch()
          },
        },
        model: {
          value: _vm.fields.password,
          callback: function ($$v) {
            _vm.$set(_vm.fields, "password", $$v)
          },
          expression: "fields.password",
        },
      }),
      _c(
        "v-row",
        { staticClass: "pt-10", attrs: { justify: "end", "no-gutters": "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "mr-4",
              attrs: {
                color: "primary",
                type: "submit",
                disabled: _vm.loading,
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("page-sign-in.title-button")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }